import { useEffect, useState } from "react";
import { supabase } from "./lib/supabase";

type SharedDocument={document_path:string|null;uploaded_filename:string|null};

export default function WeldPackagePage({token}:{token:string}){
 const [error,setError]=useState("");
 useEffect(()=>{
  let objectUrl="";
  async function openDocument(){
   const {data,error}=await supabase.rpc("get_shared_weld_wpds_document",{p_token:token});
   const record=(Array.isArray(data)?data[0]:data) as SharedDocument|null;
   if(error||!record?.document_path){setError("This WPDS QR link is unavailable, disabled, or has no controlled document attached.");return;}
   const downloaded=await supabase.storage.from("procedure-documents").download(record.document_path);
   if(downloaded.error||!downloaded.data){setError("ArcVault could not open the controlled WPDS document.");return;}
   objectUrl=URL.createObjectURL(downloaded.data);
   window.location.replace(objectUrl);
  }
  void openDocument();
  return()=>{if(objectUrl)URL.revokeObjectURL(objectUrl)};
 },[token]);
 if(error)return <main className="scan-page"><div className="scan-card"><p className="eyebrow">ARCVAULT QR</p><h1>WPDS unavailable</h1><div className="form-message">{error}</div></div></main>;
 return <main className="scan-page"><div className="scan-card"><p>Opening controlled WPDS document…</p></div></main>;
}
